import type {
  CheckoutReceipts,
  FxLatencyReceiptSource,
  Instalments,
  Receipt,
} from '../types';
import { amount, createReceipt } from './common';
import { ONE_INSTALMENT, TWO_INSTALMENTS } from './instalments';

// Visa `payment_type` code used as an fx_latency key.
export const FX_LATENCY_PAYMENT_TYPE_CODE = 'visa';

// Boleto `payment_type` code used as an fx_latency key.
export const BOLETO_PAYMENT_TYPE_CODE = 'boleto';

const BUFFERED_RECEIPT = createReceipt({
  fx: {
    from: 'USD',
    to: 'BRL',
    rate: '4.2100',
  },
  amount_local_base: amount('BRL', '421.00'),
  amount_local_total: amount('BRL', '422.60'),
  local_taxes: [
    {
      code: 'BR_IOF',
      amount: amount('BRL', '1.60'),
      rate: '0.0038',
    },
  ],
});

const bufferedInstalment = (instalments: number, partial: string): Receipt =>
  createReceipt({
    ...BUFFERED_RECEIPT,
    instalments_plan: {
      instalments,
      amount_partial_first: amount('BRL', partial),
      amount_partial_other: amount('BRL', partial),
    },
  });

const bufferedSource = (instalments: Instalments): FxLatencyReceiptSource => ({
  main: { ...BUFFERED_RECEIPT },
  instalments,
});

export const TWO_INSTALMENTS_WITH_FX_LATENCY: CheckoutReceipts = {
  ...TWO_INSTALMENTS,
  fx_latency: {
    [FX_LATENCY_PAYMENT_TYPE_CODE]: bufferedSource({
      [1]: bufferedInstalment(1, '422.60'),
      [2]: bufferedInstalment(2, '211.30'),
    }),
  },
};

export const ONE_INSTALMENT_WITH_BOLETO_FX_LATENCY: CheckoutReceipts = {
  ...ONE_INSTALMENT,
  fx_latency: {
    [BOLETO_PAYMENT_TYPE_CODE]: bufferedSource({
      [1]: bufferedInstalment(1, '422.60'),
    }),
  },
};
